import { render, staticRenderFns } from "./VOrder.vue?vue&type=template&id=0ff0bcd3&scoped=true&"
import script from "./VOrder.vue?vue&type=script&lang=js&"
export * from "./VOrder.vue?vue&type=script&lang=js&"
import style0 from "./VOrder.vue?vue&type=style&index=0&id=0ff0bcd3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0bcd3",
  null
  
)

export default component.exports